import { Link } from 'react-router';
import type { FeedItem } from '../lib/api';
import { feedLines } from '../lib/feed';
import { formatClockTime, shortAddress } from '../lib/format';
import { Empty } from './bits';
import s from './FeedLog.module.css';

/** The live log: `06:42:11  0x82f…9e1 found proof #881`. */
export function FeedLog({
  items,
  withSymbol = false,
  empty,
  max = 80,
  testId = 'live-log',
}: {
  items: FeedItem[];
  withSymbol?: boolean;
  empty: string;
  max?: number;
  testId?: string;
}) {
  if (items.length === 0) return <Empty>{empty}</Empty>;
  return (
    <ol className={s.log} data-testid={testId} aria-live="polite" aria-relevant="additions">
      {items.slice(0, max).map((item) =>
        feedLines(item, withSymbol).map((line, j) => (
          <li key={line.key} className={s.line} data-tone={line.tone}>
            <span className={s.time}>{j === 0 ? formatClockTime(item.timestamp) : ''}</span>
            <span className={s.text}>
              {line.segs.map((seg, k) =>
                seg.t === 'addr' ? (
                  <span key={k} className="mono" title={seg.v}>
                    {shortAddress(seg.v)}
                  </span>
                ) : seg.t === 'num' && withSymbol && k === 0 ? (
                  <Link key={k} to={`/t/${item.launch}`}>
                    {seg.v}
                  </Link>
                ) : (
                  <span key={k} className={seg.t === 'num' ? s.num : undefined}>
                    {seg.v}
                  </span>
                ),
              )}
            </span>
          </li>
        )),
      )}
    </ol>
  );
}
